import { createSlice } from '@reduxjs/toolkit';

import { callerCreator } from '../callerCreator';

const initialState = {
  insurance_requests_list: {
    loading: false,
    error: null,
    insurance_requests: [],
    page_number: 1,
    total_pages: 1,
  },
  fast_quotes_list: {
    loading: false,
    error: null,
    fast_quotes: [],
    page_number: 1,
    total_pages: 1,
  },
  metlife_quotes: {
    loading: true,
    error: null,
    quoteId: null,
    quote: {
      request_id: '',
      pack_type: '',
      company: '',
      plan: '',
      name: '',
      dc: '',
      ip: '',
      diaria_ricovero: '',
      diaria_gesso: '',
      premio_annuo: '',
      ulc: '',
      ulc_premio_aggiuntivo: '',
      rsm: '',
      rsm_premio_aggiuntivo: '',
    },
    customer: {
      name: '',
      surname: '',
      gender: '',
      fiscal_code: '',
      phone: '',
      email: '',
      date_of_birth: '',
      country_of_birth_code: '',
      province_of_birth_code: '',
      commune_of_birth_code: '',
      born_abroad: 0,
      residence_province_code: '',
      residence_commune_code: '',
      postal_code: '',
      address: '',
      house_number: '',
      civil_status_id: 1,
      education_level_id: 4,
      profession_id: 13,
    },
    extensions: [],
    isSaving: false,
    saved: false,
    insuranceRequest: null,
  },
  auto_quotes: {
    loading: true,
    requestInfo: null,
    quotes: null,
    failedQuotes: null,
    noQuotes: false,
    coverages: [],
    related_quotations: [],
    markupPercentage: 0,
    preventivas_quotes: [],
    sortBy: 'amount',
    error: null,
    report: null,
    loadingReport: false,
    quotations: null,
    addingQuote: false,
    processingQuote: null,
    riskQuotations: null,
    thread: null,
    est_provvigioni: null,
  },
  profession_quotes: {
    loading: true,
    extensions: null,
    userData: null,
    profession: null,
    quoteId: null,
    selling_point: 0,
    distance_token: null,
    customer: null,
    error: null,
    quotations: null,
    addingQuote: false,
    processingQuote: null,
    riskQuotations: null,
    failedQuotes: null,
    thread: null,
    est_provvigioni: null,
  },
  travel_quotes: {
    loading: true,
    insuranceRequest: null,
    quotations: [],
    error: null,
    failedQuotations: [],
    customer: null,
    quotes: null,
    addingQuote: false,
    processingQuote: null,
    riskQuotations: null,
    thread: null,
    est_provvigioni: null,
  },
  commercial_quotes: {
    loading: true,
    insuranceRequest: null,
    quotations: [],
    quotes: [],
    error: null,
    companyData: null,
    processingQuote: null,
    failedQuotes: null,
    addingQuote: false,
    sortBy: 'amount',
    commercial_company_report: null,
    risk_quotations: null,
    thread: null,
    est_provvigioni: null,
  },
  moto_quotes: {
    loading: true,
    requestInfo: null,
    quotes: null,
    failedQuotes: null,
    noQuotes: false,
    coverages: [],
    related_quotations: [],
    markupPercentage: 0,
    preventivas_quotes: [],
    error: null,
    quotations: null,
    addingQuote: false,
    processingQuote: null,
    tutelaLegaleQuote: null,
    risk_quotations: null,
    thread: null,
    est_provvigioni: null,
  },
  renewals: {
    loading: true,
    error: null,
    renewals: [],
    page_number: 1,
    total_pages: 1,
  },
  tutela_legale_quotes: {
    loading: true,
    userData: null,
    quoteId: null,
    selling_point: 0,
    distance_token: null,
    customer: null,
    error: null,
    quotations: null,
    addingQuote: false,
    processingQuote: null,
    // tutelaLegaleQuote: null,
    riskQuotations: null,
    thread: null,
    est_provvigioni: null,
  },
  house_quotes: {
    loading: true,
    insuranceRequest: null,
    quoteId: null,
    selling_point: 0,
    distance_token: null,
    customer: null,
    error: null,
    quotations: null,
    addingQuote: false,
    processingQuote: null,
    riskQuotations: null,
    failedQuotes: [],
    thread: null,
    est_provvigioni: null,
  },
  salute_quotes: {
    loading: true,
    insuranceRequest: null,
    quoteId: null,
    selling_point: 0,
    distance_token: null,
    customer: null,
    error: null,
    quotations: null,
    addingQuote: false,
    processingQuote: null,
    riskQuotations: null,
    toSelect: [],
    quote_id_to_add: null,
    thread: null,
    est_provvigioni: null,
  },
  ancillari_auto_quotes: {
    loading: true,
    insuranceRequest: null,
    quoteId: null,
    selling_point: 0,
    distance_token: null,
    customer: null,
    error: null,
    quotations: null,
    addingQuote: false,
    processingQuote: null,
    riskQuotations: null,
    vehicle: null,
    failedQuotes: [],
    thread: null,
    est_provvigioni: null,
  },
  sanitaria_stranieri_quotes: {
    loading: true,
    insuranceRequest: null,
    quoteId: null,
    selling_point: 0,
    distance_token: null,
    customer: null,
    error: null,
    quotations: null,
    addingQuote: false,
    processingQuote: null,
    riskQuotations: null,
    vehicle: null,
    failedQuotes: [],
    thread: null,
    est_provvigioni: null,
  },
  professioni_sanita: {
    loading: true,
    insuranceRequest: null,
    quoteId: null,
    selling_point: 0,
    distance_token: null,
    customer: null,
    error: null,
    quotations: null,
    addingQuote: false,
    processingQuote: null,
    riskQuotations: null,
    failedQuotes: [],
    thread: null,
    est_provvigioni: null,
  },
  public_employment: {
    loading: true,
    insuranceRequest: null,
    quoteId: null,
    selling_point: 0,
    distance_token: null,
    customer: null,
    error: null,
    quotations: null,
    addingQuote: false,
    processingQuote: null,
    riskQuotations: null,
    toSelect: [],
    quote_id_to_add: null,
    thread: null,
    est_provvigioni: null,
  },
  malattia: {
    loading: true,
    insuranceRequest: null,
    quoteId: null,
    selling_point: 0,
    distance_token: null,
    customer: null,
    error: null,
    quotations: null,
    addingQuote: false,
    processingQuote: null,
    riskQuotations: null,
    toSelect: [],
    quote_id_to_add: null,
    thread: null,
    est_provvigioni: null,
  },
  infortunio: {
    loading: true,
    insuranceRequest: null,
    quoteId: null,
    selling_point: 0,
    distance_token: null,
    customer: null,
    error: null,
    quotations: null,
    addingQuote: false,
    processingQuote: null,
    riskQuotations: null,
    toSelect: [],
    quote_id_to_add: null,
    thread: null,
    est_provvigioni: null,
  },
  condominio: {
    loading: true,
    insuranceRequest: null,
    quoteId: null,
    selling_point: 0,
    distance_token: null,
    customer: null,
    error: null,
    quotations: null,
    addingQuote: false,
    processingQuote: null,
    riskQuotations: null,
    toSelect: [],
    quote_id_to_add: null,
    thread: null,
    est_provvigioni: null,
  },
  rc_famiglia: {
    loading: true,
    insuranceRequest: null,
    quoteId: null,
    selling_point: 0,
    distance_token: null,
    customer: null,
    error: null,
    quotations: null,
    addingQuote: false,
    processingQuote: null,
    riskQuotations: null,
    toSelect: [],
    quote_id_to_add: null,
    thread: null,
    est_provvigioni: null,
  },
  monopattini: {
    loading: true,
    insuranceRequest: null,
    quoteId: null,
    selling_point: 0,
    distance_token: null,
    customer: null,
    error: null,
    quotations: null,
    addingQuote: false,
    processingQuote: null,
    riskQuotations: null,
    toSelect: [],
    quote_id_to_add: null,
  },

};

export const insuranceRequestsSlice = createSlice({
  name: 'insuranceRequests',
  initialState,
  reducers: {
    listInsuranceRequestsPending: (state) => {
      state.insurance_requests_list.loading = true;
      state.insurance_requests_list.error = null;
    },
    listInsuranceRequestsReject: (state, { payload }) => {
      state.insurance_requests_list.loading = false;
      state.insurance_requests_list.error = payload;
    },
    listInsuranceRequestsSuccess: (state, { payload }) => {
      state.insurance_requests_list.loading = false;
      state.insurance_requests_list.insurance_requests = payload.data;
      state.insurance_requests_list.page_number = payload.current_page;
      state.insurance_requests_list.total_pages = payload.total_pages;
    },
    insuranceRequestsReset: (state) => {
      state.insurance_requests_list = { ...initialState.insurance_requests_list };
    },

    listFastQuotesPending: (state) => {
      state.fast_quotes_list.loading = true;
      state.fast_quotes_list.error = null;
    },
    listFastQuotesReject: (state, { payload }) => {
      state.fast_quotes_list.loading = false;
      state.fast_quotes_list.error = payload;
    },
    listFastQuotesSuccess: (state, { payload }) => {
      state.fast_quotes_list.loading = false;
      state.fast_quotes_list.fast_quotes = payload.data;
      state.fast_quotes_list.page_number = payload.current_page;
      state.fast_quotes_list.total_pages = payload.total_pages;
    },

    fastQuotesReset: (state) => {
      state.fast_quotes_list = { ...initialState.fast_quotes_list };
    },
    metlifeQuotesDataUpdated: (state, { payload }) => {
      state.metlife_quotes = { ...state.metlife_quotes, ...payload };
    },
    infortuniQuotesUpdateExtensions: (state, { payload }) => {
      const { extensions } = state.metlife_quotes;
      let newExtensions = [];

      if (extensions.includes(payload)) {
        newExtensions = extensions.filter((extension) => extension !== payload);
      } else {
        newExtensions = [...extensions, payload];
      }
      state.metlife_quotes.extensions = newExtensions;
    },
    infortuniQuotesReset: (state) => {
      state.metlife_quotes = { ...initialState.metlife_quotes };
    },

    autoQuotesToggleCoverages: (state, { payload }) => {
      const coverageId = payload;
      const { coverages } = state.auto_quotes;
      let newCoverages = [];
      if (coverages.find((c) => c === coverageId) === undefined) {
        newCoverages = [...coverages, coverageId];
      } else {
        newCoverages = coverages.filter((c) => c !== coverageId);
      }
      state.auto_quotes.coverages = newCoverages;
    },
    autoQuotesCoveragesSet: (state, { payload }) => {
      state.auto_quotes.coverages = payload;
    },
    motoQuotesToggleCoverages: (state, { payload }) => {
      const coverageId = payload;
      const { coverages } = state.moto_quotes;
      let newCoverages = [];
      if (coverages.find((c) => c === coverageId) === undefined) {
        newCoverages = [...coverages, coverageId];
      } else {
        newCoverages = coverages.filter((c) => c !== coverageId);
      }
      state.moto_quotes.coverages = newCoverages;
    },
    motoQuotesCoveragesSet: (state, { payload }) => {
      state.moto_quotes.coverages = payload;
    },

    autoQuotesRequestInfoUpdated: (state, { payload }) => {
      state.auto_quotes.requestInfo = {
        ...payload.quotations[0],
      };
      state.auto_quotes.loading = false;
      state.auto_quotes.related_quotations = payload.related_quotations;
      state.auto_quotes.preventivas_quotes = payload.preventivas_quotes;
      state.auto_quotes.quotations = payload.quotations[0].quotes;
      state.auto_quotes.processingQuote = payload.processingQuote;
      state.auto_quotes.riskQuotations = payload.risk_quotations;
      state.auto_quotes.thread = payload.thread;
      state.auto_quotes.est_provvigioni = payload.stimaProvvigioni;
    },
    autoQuotesRequestInfoRejected: (state, { payload }) => {
      state.auto_quotes.error = payload.error;
      state.auto_quotes.loading = false;
    },
    autoQuotesRequestInfoSilentUpdated: (state, { payload }) => {
      state.auto_quotes.requestInfo = {
        ...payload.quotations[0],
      };
      // A silent refresh only ever becomes the applied update when the
      // shared request-id guard in loadAutoQuotes/silentLoadAutoQuotes has
      // already recognized it as the latest in-flight call — meaning any
      // earlier loadAutoQuotes call (the one actually wired to clear
      // `loading`) has been discarded as stale. Clear it here too, or a
      // discarded-but-successful loadAutoQuotes response leaves the page
      // stuck on the loading spinner forever.
      state.auto_quotes.loading = false;
      state.auto_quotes.related_quotations = payload.related_quotations;
      state.auto_quotes.preventivas_quotes = payload.preventivas_quotes;
      state.auto_quotes.quotations = payload.quotations[0].quotes;
      state.auto_quotes.processingQuote = payload.processingQuote;
      state.auto_quotes.riskQuotations = payload.risk_quotations;
      state.auto_quotes.thread = payload.thread;
      state.auto_quotes.est_provvigioni = payload.stimaProvvigioni;
    },
    autoQuotesRequestInfoSilentRejected: (state, { payload }) => {
      state.auto_quotes.error = payload.error;
      state.auto_quotes.loading = false;
    },
    motoQuotesRequestInfoUpdated: (state, { payload }) => {
      state.moto_quotes.requestInfo = {
        ...payload.quotations[0],
      };
      state.moto_quotes.loading = false;
      state.moto_quotes.related_quotations = payload.related_quotations;
      // state.moto_quotes.preventivas_quotes = payload.preventivas_quotes;
      state.moto_quotes.quotations = payload.quotations[0].quotes;
      state.moto_quotes.processingQuote = payload.processingQuote;
      state.moto_quotes.risk_quotations = payload.risk_quotations;
      state.moto_quotes.thread = payload.thread;
      state.moto_quotes.est_provvigioni = payload.stimaProvvigioni;
    },
    motoQuotesRequestInfoRejected: (state, { payload }) => {
      state.moto_quotes.error = payload.error;
      state.moto_quotes.loading = false;
    },
    motoQuotesRequestInfoSilentUpdated: (state, { payload }) => {
      state.moto_quotes.requestInfo = {
        ...payload.quotations[0],
      };
      state.moto_quotes.loading = false;
      state.moto_quotes.related_quotations = payload.related_quotations;
      // state.moto_quotes.preventivas_quotes = payload.preventivas_quotes;
      state.moto_quotes.quotations = payload.quotations[0].quotes;
      state.moto_quotes.processingQuote = payload.processingQuote;
      state.moto_quotes.risk_quotations = payload.risk_quotations;
      state.moto_quotes.thread = payload.thread;
      state.moto_quotes.est_provvigioni = payload.stimaProvvigioni;
    },
    motoQuotesRequestInfoSilentRejected: (state, { payload }) => {
      state.moto_quotes.error = payload.error;
      state.moto_quotes.loading = false;
    },
    autoQuotesDataUpdated: (state, { payload }) => {
      state.auto_quotes = { ...state.auto_quotes, ...payload };
    },
    motoQuotesDataUpdated: (state, { payload }) => {
      state.moto_quotes = { ...state.moto_quotes, ...payload };
    },
    autoQuotesReset: (state) => {
      state.auto_quotes = { ...initialState.auto_quotes };
    },
    motoQuotesReset: (state) => {
      state.moto_quotes = { ...initialState.moto_quotes };
    },
    professionQuotesDataUpdated: (state, { payload }) => {
      state.profession_quotes = { ...state.profession_quotes, ...payload };
    },
    professionQuotesDataUpdatedRejected: (state, { payload }) => {
      state.profession_quotes.error = payload;
      state.profession_quotes.loading = false;
    },
    professionSilentQuotesDataUpdated: (state, { payload }) => {
      state.profession_quotes = { ...state.profession_quotes, ...payload };
      state.profession_quotes.loading = false;
    },
    professionSilentQuotesDataUpdatedRejected: (state, { payload }) => {
      state.profession_quotes.error = payload;
      state.profession_quotes.loading = false;
    },
    professionQuotesReset: (state) => {
      state.profession_quotes = { ...initialState.profession_quotes };
    },
    travelQuotesDataUpdated: (state, { payload }) => {
      state.travel_quotes = { ...state.travel_quotes, ...payload };
    },
    travelQuotesReset: (state) => {
      state.travel_quotes = { ...initialState.travel_quotes };
    },
    travelQuotesInfoDataUpdate: (state, { payload }) => {
      state.travel_quotes.insuranceRequest = payload.insuranceRequest;
      state.travel_quotes.quotations = payload.quotations;
      state.travel_quotes.failedQuotations = payload.failed_quotations;
      state.travel_quotes.customer = payload.customer;
    },

    listRenewalsPending: (state) => {
      state.renewals.loading = true;
      state.renewals.error = null;
    },
    listRenewalsReject: (state, { payload }) => {
      state.renewals.loading = false;
      state.renewals.error = payload;
    },
    listRenewalsSuccess: (state, { payload }) => {
      state.renewals.loading = false;
      state.renewals.renewals = payload.renewals.data;
      state.renewals.page_number = payload.renewals.current_page;
      state.renewals.total_pages = payload.renewals.last_page;
    },
    listRenewalsReset: (state) => {
      state.renewals = { ...initialState.renewals };
    },
    commercialQuotesDataUpdated: (state, { payload }) => {
      state.commercial_quotes = { ...state.commercial_quotes, ...payload };
    },
    commercialQuotesReset: (state) => {
      state.commercial_quotes = { ...initialState.commercial_quotes };
    },
    tutelaLegaleQuotesDataUpdated: (state, { payload }) => {
      state.tutela_legale_quotes = {
        ...state.tutela_legale_quotes,
        ...payload,
      };
    },
    tutelaLegaleQuotesDataUpdatedRejected: (state, { payload }) => {
      state.tutela_legale_quotes.error = payload;
      state.tutela_legale_quotes.loading = false;
    },
    tutelaLegaleQuotesReset: (state) => {
      state.tutela_legale_quotes = { ...initialState.tutela_legale_quotes };
    },
    addVehicleAmountPending: (state) => {
      state.auto_quotes.loading = true;
      state.auto_quotes.error = null;
    },
    addVehicleAmountRejected: (state, { payload }) => {
      state.auto_quotes.loading = false;
      state.auto_quotes.error = payload;
    },
    addVehicleAmountSuccess: (state) => {
      state.auto_quotes.loading = false;
    },
    houseQuotesDataUpdated: (state, { payload }) => {
      state.house_quotes = { ...state.house_quotes, ...payload };
    },
    houseQuotesDataUpdatedRejected: (state, { payload }) => {
      state.house_quotes.error = payload;
      state.house_quotes.loading = false;
    },
    houseQuotesDataSilentUpdated: (state, { payload }) => {
      state.house_quotes = { ...state.house_quotes, ...payload };
      state.house_quotes.loading = false;
    },
    houseQuotesDataSilentUpdatedRejected: (state, { payload }) => {
      state.house_quotes.error = payload;
      state.house_quotes.loading = false;
    },
    houseQuotesReset: (state) => {
      state.house_quotes = { ...initialState.house_quotes };
    },
    saluteQuotesDataUpdated: (state, { payload }) => {
      state.salute_quotes = { ...state.salute_quotes, ...payload };
    },
    saluteQuotesDataUpdatedRejected: (state, { payload }) => {
      state.salute_quotes.error = payload;
      state.salute_quotes.loading = false;
    },
    saluteQuotesReset: (state) => {
      state.salute_quotes = { ...initialState.salute_quotes };
    },
    ancillariAutoQuotesDataUpdated: (state, { payload }) => {
      state.ancillari_auto_quotes = { ...state.ancillari_auto_quotes, ...payload };
    },
    ancillariAutoQuotesDataUpdatedRejected: (state, { payload }) => {
      state.ancillari_auto_quotes.error = payload;
      state.ancillari_auto_quotes.loading = false;
    },
    ancillariAutoQuotesReset: (state) => {
      state.ancillari_auto_quotes = { ...initialState.ancillari_auto_quotes };
    },
    ancillariAutoQuotesDataSilentUpdated: (state, { payload }) => {
      state.ancillari_auto_quotes = { ...state.ancillari_auto_quotes, ...payload };
    },
    ancillariAutoQuotesDataSilentRejected: (state, { payload }) => {
      state.ancillari_auto_quotes.error = payload.error;
    },
    sanitariaStranieriQuotesDataUpdated: (state, { payload }) => {
      state.sanitaria_stranieri_quotes = { ...state.sanitaria_stranieri_quotes, ...payload };
    },
    sanitariaStranieriQuotesDataUpdatedRejected: (state, { payload }) => {
      state.sanitaria_stranieri_quotes.error = payload;
      state.sanitaria_stranieri_quotes.loading = false;
    },
    sanitariaStranieriQuotesReset: (state) => {
      state.sanitaria_stranieri_quotes = { ...initialState.sanitaria_stranieri_quotes };
    },
    professioneStranieriQuotesDataUpdated: (state, { payload }) => {
      state.professioni_sanita = { ...state.professioni_sanita, ...payload };
    },
    professioneStranieriQuotesDataUpdatedRejected: (state, { payload }) => {
      state.professioni_sanita.error = payload;
      state.professioni_sanita.loading = false;
    },
    professioneStranieriQuotesReset: (state) => {
      state.professioni_sanita = { ...initialState.professioni_sanita };
    },
    publicEmploymentQuotesDataUpdated: (state, { payload }) => {
      state.public_employment = { ...state.public_employment, ...payload };
    },
    publicEmploymentQuotesDataUpdatedRejected: (state, { payload }) => {
      state.public_employment.error = payload;
      state.public_employment.loading = false;
    },
    publicEmploymentQuotesReset: (state) => {
      state.public_employment = { ...initialState.public_employment };
    },
    malattiaQuotesDataUpdated: (state, { payload }) => {
      state.malattia = { ...state.malattia, ...payload };
    },
    malattiaQuotesDataUpdatedRejected: (state, { payload }) => {
      state.malattia.error = payload;
      state.malattia.loading = false;
    },
    malattiaQuotesReset: (state) => {
      state.malattia = { ...initialState.malattia };
    },
    infortunioQuotesDataUpdated: (state, { payload }) => {
      state.infortunio = { ...state.infortunio, ...payload };
    },
    infortunioQuotesDataUpdatedRejected: (state, { payload }) => {
      state.infortunio.error = payload;
      state.infortunio.loading = false;
    },
    infortunioQuotesReset: (state) => {
      state.infortunio = { ...initialState.infortunio };
    },
    condominioQuotesDataUpdated: (state, { payload }) => {
      state.condominio = { ...state.condominio, ...payload };
    },
    condominioQuotesDataUpdatedRejected: (state, { payload }) => {
      state.condominio.error = payload;
      state.condominio.loading = false;
    },
    condominioQuotesSilentDataUpdated: (state, { payload }) => {
      state.condominio = { ...state.condominio, ...payload };
    },
    condominioQuotesDataSilentUpdatedRejected: (state, { payload }) => {
      state.condominio.error = payload;
    },
    condominioQuotesReset: (state) => {
      state.condominio = { ...initialState.condominio };
    },
    addMassimaleCondominioAmountPending: (state) => {
      state.condominio.loading = true;
      state.condominio.error = null;
    },
    addMassimaleCondominioAmountRejected: (state, { payload }) => {
      state.condominio.loading = false;
      state.condominio.error = payload;
    },
    addMassimaleCondominioAmountSuccess: (state) => {
      state.condominio.loading = false;
    },
    rcFamigliaQuotesDataUpdated: (state, { payload }) => {
      state.rc_famiglia = { ...state.rc_famiglia, ...payload };
    },
    rcFamigliaQuotesDataUpdatedRejected: (state, { payload }) => {
      state.rc_famiglia.error = payload;
      state.rc_famiglia.loading = false;
    },
    rcFamigliaQuotesReset: (state) => {
      state.rc_famiglia = { ...initialState.rc_famiglia };
    },
    monopattiniQuotesDataUpdated: (state, { payload }) => {
      state.monopattini = { ...state.monopattini, ...payload };
    },
    monopattiniQuotesDataUpdatedRejected: (state, { payload }) => {
      state.monopattini.error = payload;
      state.monopattini.loading = false;
    },
    monopattiniQuotesReset: (state) => {
      state.monopattini = { ...initialState.monopattini };
    },
  },
});

export default callerCreator(insuranceRequestsSlice.actions);
